import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { combineLatest, map } from 'rxjs';
import { JobCounts } from 'server/shared/helpers/getJobCounts';
import { SettingsService } from '../../services/settings.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-job-list-item-counts',
  templateUrl: './job-list-item-counts.component.html',
  styleUrls: ['./job-list-item-counts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobListItemCountsComponent {
  @Input() counts?: JobCounts;

  @Input() hidePotentialInviteeCount = false;

  isAdmin$ = this.userService.isAdmin$;

  showPotentialInviteeCount$ = combineLatest([
    this.userService.isAdmin$,
    this.settingsService.potentialInviteeCountsEnabled$,
  ]).pipe(map(([isAdmin, settingEnabled]) => isAdmin || settingEnabled));

  constructor(
    private userService: UserService,
    private settingsService: SettingsService,
  ) {}
}
